// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2XtZQ","cell":"ColumnAccessor_cell__2tAf2","firstCellAccent":"ColumnAccessor_firstCellAccent__2CS3F"};